import styles from './Button.module.scss';

interface buttonProps {
    text: string;
    customClass?: string;
    onClickButton: () => void;
}
const Button = ({ text, onClickButton, customClass }: buttonProps) => {
    return (
        <button className={`${styles.button} ${customClass}`} onClick={onClickButton}>
            {text}
        </button>
    );
};

export default Button;
